import * as React from 'react';

import { BuilderStat } from '../../../../../../components/Field/newBuildingFlatSale/BuilderField/BuilderStatsField';
import { trackNavigationToListing } from './tracking';
import { useOfferContext } from '../../../../../../utils/offerContext';
import { getBuilderStatsFromOffer } from '../../../../../../utils/builder';

export const BuilderStatsFieldContainer: React.VFC = () => {
  const offer = useOfferContext();
  const { done, inProgress } = getBuilderStatsFromOffer(offer) || {};
  const { querystring: doneQueryString = '' } = done || {};
  const { querystring: inProgressQueryString = '' } = inProgress || {};

  const handleDoneStatClick = React.useCallback(() => {
    trackNavigationToListing({ queryString: doneQueryString });
  }, [doneQueryString]);

  const handleInProgressStatClick = React.useCallback(() => {
    trackNavigationToListing({ queryString: inProgressQueryString });
  }, [inProgressQueryString]);

  return (
    <>
      {done && (
        <BuilderStat statusText={done.statusText} text={done.text} url={done.url} onClick={handleDoneStatClick} />
      )}
      {inProgress && (
        <BuilderStat
          statusText={inProgress.statusText}
          text={inProgress.text}
          url={inProgress.url}
          onClick={handleInProgressStatClick}
        />
      )}
    </>
  );
};
